


















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddFreight {
        warehouseInfoId: number;
        cargoCategory: number;
        isSend: boolean = false;
        weight: number=0;
        long: number=0;
        wide: number=0;
        high: number=0;
        mainLandInterNationalShipment: string;
    }
    @Component
    export default class CreatefreightModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        freight: AddFreight = new AddFreight();
        selectDate: string = "";
        selectDates: string = "";
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        cargoCategoryType = Enums.CargoCategoryType;
        addLoding = false;
        amountTotal: string = '';;
        created() {
            this.getCity();
        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'mainlandpackage/editMainLandPackage',
                        data: this.freight
                    }).finally(() => {
                        this.addLoding = false;
                    });

                    (this.$refs.freightCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);

                }
            })
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.freight.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.freightCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        freightRule = {
            warehouseId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            
            mainLandInterNationalShipment: [
                { required: true, message: '麻袋编号不能为空', trigger: 'blur' }
            ],
            //weight: [
            //    { required: true, message: '重量不能为空，单位为g', trigger: 'blur' }
            //],
            //long: [
            //    { required: true, message: '长度不能为空【cm】', trigger: 'blur' }
            //],
            //wide: [
            //    { required: true, message: '宽度不能为空【cm】', trigger: 'blur' }
            //],
            //high: [
            //    { required: true, message: '高度不能为空【cm】', trigger: 'blur' }
            //],
        };

    }
